'use strict';

import request from 'superagent';
import api from './core';

export function fetchPage(args) {
    return api.prepare(request.get(api.url('/protocols/'))).query(args);
}

export function list(args) {
    return api.forwardResult(fetchPage(args), 'results');
}

export function create(protocol) {
    return api.forwardResult(
        api.prepare(request.post(api.url('/protocols/'))).send(protocol),
        'id'
    );
}

export function update(protocol) {
    const id = encodeURIComponent(protocol.id);
    return api.forwardResult(
        api.prepare(request.put(api.url(`/protocols/${id}/`))).send(protocol),
        'id'
    );
}



// WEBPACK FOOTER //
// ./src/api/protocols.js